export default __webpack_public_path__ + "static/media/icon_privacy_home_safety_base.6bf7eff8.svg";